

import { useNavigate } from "react-router-dom";
import FreePlanCard from "./cards/FreePlanCard";
import PremiumPlanCard from "./cards/PremiumPlanCard";
import FamilyPlanCard from "./cards/FamilyPlanCard";
import { pricingConfig } from "@/hooks/subscription/types";

interface PricingCardsProps {
  billingPeriod: "monthly" | "yearly";
}

const PricingCards = ({ billingPeriod }: PricingCardsProps) => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/auth/signup');
  };

  const handleContactUs = () => {
    navigate('/contact');
  };

  const freeFeatures = [
    "Training Journal",
    "Technique Library",
    "Concepts & Mindset Section",
    "Community Forum (optional)"
  ];

  const premiumFeatures = [
    ...freeFeatures,
    "Training Journal Insights",
    "Game Planner",
    "Personal Vault: Upload Videos/Notes",
    "Premium Support",
    "Strategy Templates",
    "Merch Discounts"
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto px-2 sm:px-4">
      <FreePlanCard 
        features={freeFeatures} 
        handleGetStarted={handleGetStarted} 
      />
      
      <PremiumPlanCard 
        features={premiumFeatures} 
        billingPeriod={billingPeriod}
        handleGetStarted={handleGetStarted} 
        pricingConfig={pricingConfig}
      />
      
      <FamilyPlanCard 
        billingPeriod={billingPeriod}
        handleGetStarted={handleContactUs} 
        pricingConfig={pricingConfig}
      />
    </div>
  );
};

export default PricingCards;
